import { isEmptyValue } from "@lyfegen-platform/utils";
import { RoleOptions, TasksTimeframe } from "apps/platform-client/client/src/models/enums/enums";
import { QuestCompletionStatus, UserQuestsConnectionWhere, UserTasksConnectionWhere } from "../../../../models/generated/graphql";
import { AgreementUserRole, UserWhere } from "apps/platform-client/client/src/types/graphql-global-types";
import { getIntervalTimeframe } from "../tasks/inbox-tasks-filter-service";

export function getBasicQuestUserFilter(userId: string) {
	return {
		id: userId,
		OR: [
			{
				quests: {
					case: {
						baseAgreement: {
							isDeleted: false,
							userRolesConnection: {
								edge: { role_NOT_IN: [AgreementUserRole.LIMITED_ACCESS_USER, AgreementUserRole.FULL_ACCESS_USER] },
								node: { id: userId },
							},
						},
					},
				},
			},
			{
				quests: {
					triggerEventId: 3,
				},
			},
		],
	} as UserWhere;
}

export function getBasicQuestFilter(questIds: number[]) {
	return {
		node: { triggerEventId_IN: questIds },
	} as UserQuestsConnectionWhere;
}

export function setTimeframeFilters(timeFrameFilter: any, questFilter: UserQuestsConnectionWhere): UserTasksConnectionWhere {
	if (
		!timeFrameFilter ||
		!timeFrameFilter.length ||
		timeFrameFilter === TasksTimeframe.AnyTime ||
		timeFrameFilter.includes(TasksTimeframe.AnyTime)
	)
		return questFilter;
	const [startIntervalDate, endIntervalDate] = getIntervalTimeframe(timeFrameFilter!);

	return {
		...questFilter,
		node: {
			...questFilter.node,
			timeStamp_GTE: startIntervalDate,
			timeStamp_LTE: endIntervalDate,
		},
	} as UserQuestsConnectionWhere;
}

export function setUnresolvedFilters(unresolvedFilter: any, questFilter: UserQuestsConnectionWhere): UserTasksConnectionWhere {
	if (!unresolvedFilter) return questFilter;

	return {
		...questFilter,
		node: {
			...questFilter.node,
			completionStatus: QuestCompletionStatus.Active,
		},
	} as UserQuestsConnectionWhere;
}

export function setMyRoleFilters(myRoleFilter: any, userId: string, questFilter: UserQuestsConnectionWhere): UserQuestsConnectionWhere {
	if (!myRoleFilter || !myRoleFilter.length || myRoleFilter === RoleOptions.AnyRole || myRoleFilter.includes(RoleOptions.AnyRole))
		return questFilter;

	return {
		...questFilter,
		node: {
			...questFilter.node,
			case:
				myRoleFilter === RoleOptions.AssignedToMe || myRoleFilter.includes(RoleOptions.AssignedToMe)
					? {
							caseAssignee_SOME: { id: userId },
					  }
					: undefined,
			usersRelationshipConnection_SOME:
				myRoleFilter === RoleOptions.OwnedByMe || myRoleFilter.includes(RoleOptions.OwnedByMe)
					? {
							edge: {
								isOwner: true,
							},
							node: { id: userId },
					  }
					: undefined,
		},
	} as UserQuestsConnectionWhere;
}

export function searchItem(
	searchItem: string,
	questFilter: UserQuestsConnectionWhere,
	preferredLanguage: string
): UserTasksConnectionWhere {
	const trimmedSearchValue = searchItem.trim().toLowerCase();
	if (isEmptyValue(searchItem)) return questFilter;
	return {
		...questFilter,
		node: {
			...questFilter.node,
			...(preferredLanguage === "en-US"
				? { questContentEn_CONTAINS: trimmedSearchValue }
				: { questContentDe_CONTAINS: trimmedSearchValue }),
		},
	} as UserQuestsConnectionWhere;
}
